import { Omit } from '@40seas/entities/common';
import { SegmentEntityFieldsArray } from '@40seas/models';
import { Identity } from './identity.entity';

export class CreateIdentityDto extends Omit(Identity, [...SegmentEntityFieldsArray], []) {}
